import { Container, Row, Col, Button } from 'react-bootstrap';
import AcubeIntroVideo from '../../../../components/videos/acube-video';
import { useScroll } from '../../../../context/scroll-context';
import groupImg from "../../../../images/company/group-img.webp";

const AboutTeam = () => {
    const { scrollToSection, contactform } = useScroll();

    const handleScrollAndClose = (refName) => {
        scrollToSection(refName);
    };

    return (
        <section className="py-5">
            <Container>
                <Row className="mb-4">
                    <Col xs={12} md={6}>
                        <AcubeIntroVideo />
                    </Col>
                    <Col xs={12} md={6} className="d-flex align-items-center">
                        <div className="text-primary">
                            <h2>The Leading Technology Solutions Provider</h2>
                            <p>
                                At Acube, we help transform your business challenges Into growth opportunities. Our IT services are geared to provide the best tools and processes for your business success. Acube has been offering software development services to global clients in the U.S., Canada, Europe, Australia, and Egypt since 2010.
                                <br></br>
                                We work with proven systems that engage the right people, skills, and technology, to help clients have a competitive edge in the market. Most importantly, our software solutions are designed to ensure secure and scalable systems for your business needs.
                            </p>
                            <div>
                                <Button variant="primary" onClick={() => handleScrollAndClose(contactform)}>
                                    GET IN TOUCH
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} className="d-flex align-items-center">
                        <div className="text-primary">
                            <h2>Helping Hundred Of Companies, From Start-ups To Inc. 5000 Companies
                            </h2>
                            <p>
                                We’re way beyond just an outsourcing company. Having helped small businesses all the way to large enterprises, our team focuses on harnessing technology to streamline your process while helping you grow and scale your business.
                            </p>
                            <div>
                                <Button variant="primary" onClick={() => handleScrollAndClose(contactform)}>
                                    GET IN TOUCH
                                </Button>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6}>
                        <img src={groupImg} alt="team-group" className="img-fluid" />
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default AboutTeam;
